module.exports = __webpack_public_path__ + "static/img/quality.1650df0.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/channels/quality.png
// module id = CdIV
// module chunks = 1